import { Box, Kbd, Text, type Omittable } from "@salestrak/ui";

/**
 * Shared footer for the desktop global-search surfaces (inline bar + dialog).
 * The left side is a fixed keyboard legend; the right side is contextual to the
 * currently-highlighted row — `useGlobalSearchContent` resolves it and hands it
 * down as `context`. Omitted on mobile (touch has no arrow keys).
 */
export function GlobalSearchFooter({ context }: Omittable<{ context?: string }>) {
  return (
    // The rule alone separates the legend from the results — a fill would
    // read as a second surface inside one popup.
    <Box border="top">
      <Box
        direction="row"
        align="center"
        justify="between"
        gap="sm"
        paddingX="md"
        height={44}
      >
        <Box direction="row" align="center" gap="xs">
          <Kbd>up</Kbd>
          <Kbd>down</Kbd>
          <Text size="xs" variant="muted">
            navigate
          </Text>
          <Kbd>enter</Kbd>
          <Text size="xs" variant="muted">
            open
          </Text>
        </Box>
        {context ? (
          <Text size="xs" variant="muted">
            {context}
          </Text>
        ) : null}
      </Box>
    </Box>
  );
}
